module.exports = __webpack_public_path__ + "assets/img/fd7e17f754e0dbcf0d7ffe306e48d154.png";